import Buttons from "../buttons/buttons";
import Form from "../form/form";
import "./section1.css";
import { useState, useEffect } from "react";

function Sections({
  Titulo,
  texto1,
  texto2,
  texto3,
  texto4,
  texto5,
  texto6,
  texto7,
  srcImg,
  mostraPrecoCheio,
  cor,
  tipo,
  tituloJson,
  btnHomeTitle,
  btnHomeLink,
}) {
  const [hiddenBtn, setHiddenBtn] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [possuiDesconto, setPossuiDesconto] = useState(false);
  const [titulo, setTitulo] = useState("");
  const [log, setLog] = useState("");
  const [produtoInicial, setProdutoInicial] = useState([]);
  const [precoPor, setPrecoPor] = useState("");
  const [precoDe, setPrecoDe] = useState("");
  let tipoLayout = parseInt(tipo);
  let tentativas = 0;

  useEffect(() => {
    identifierUrl(tipoLayout);
    setTimeout(async function getFirstItem() {
      if (
        sessionStorage.getItem("@App:ecnpjA1") &&
        sessionStorage.getItem("@App:ecnpjA1") !== undefined &&
        sessionStorage.getItem("@App:ecnpjA1") !== "undefined"
      ) {
        const produto = await JSON.parse(
          sessionStorage.getItem("@App:ecnpjA1")
        );
        setProdutoInicial(produto);
        setTitulo(produto.rubri_vcds_comercial);
        setPrecoPor(
          parseFloat(produto.produ_dmvl_precovenda)
            .toFixed(2)
            .toString()
            .replace(".", ",")
        );
        if (produto.produ_dmvl_precocomdesconto) {
          setPrecoDe(
            parseFloat(produto.produ_dmvl_precovenda)
              .toFixed(2)
              .toString()
              .replace(".", ",")
          );
          setPrecoPor(
            parseFloat(produto.produ_dmvl_precocomdesconto)
              .toFixed(2)
              .toString()
              .replace(".", ",")
          );
          setPossuiDesconto(true);
        }
      } else {
        if (tentativas <= 3) {
          tentativas++;
          setTimeout(getFirstItem, 3000);
        } else {
          console.log("Não foi possível recuperar o produto inicial.");
        }
      }
    }, 1000);
  }, []);

  const tooglePopup = () => {
    setIsOpen(!isOpen);
  };

  function identifierUrl(tipoLayout) {
    if (
      btnHomeTitle !== "" &&
      btnHomeTitle !== undefined &&
      btnHomeLink !== "" &&
      btnHomeLink !== undefined &&
      (tipoLayout === 1 || tipoLayout === 3)
    ) {
      setHiddenBtn(true);
    } else {
      setHiddenBtn(false);
    }
  }

  function returnLayout(paramTipoLayout) {
    const layout =
      paramTipoLayout !== undefined &&
      paramTipoLayout !== null &&
      paramTipoLayout !== ""
        ? parseInt(paramTipoLayout)
        : tipoLayout;

    if (layout === 1) {
      return (
        <>
          <div className="col-md-6 box-center display-tc desktop animated animatedFadeInUp fadeInUp">
            <h1 className="title">{Titulo}</h1>
            <p className="text">
              {texto1}
              <br />
              <br />
              {texto2}
            </p>
            <div className="sejaparceiro">
              {hiddenBtn ? (
                <>
                  <a href={btnHomeLink} target="_blank" rel="noreferrer">
                    <Buttons btnProduct btnSejaParceiro labelBtn={btnHomeTitle} />
                  </a>
                </>
              ) : null}
            </div>
          </div>
          <div className="col-md-6 text-center mobile animated animatedFadeInUp fadeInUp">
            <img src={srcImg} alt={Titulo} />
          </div>
        </>
      );
    } else if (layout === 2) {
      return (
        <>
          <div className="col-md-6 box-center desktop animated animatedFadeInUp fadeInUp">
            <h1 className="title">{Titulo}</h1>
            <p className="text">{texto1}</p>
            <p className="text">{texto2}</p>
          </div>
          <div className="col-md-6 text-center mobile animated animatedFadeInUp fadeInUp">
            <img src={srcImg} alt={Titulo} />
          </div>
        </>
      );
    } else if (layout === 3) {
      return (
        <>
          <div className="col-md-6 box-center display-tc desktop animated animatedFadeInUp fadeInUp">
            <h1 className="title">{titulo}</h1>
            {possuiDesconto && mostraPrecoCheio && mostraPrecoCheio === "S" ? (
              <>
                <p className="text">
                  {texto1}
                  <br />
                  <br />
                  <span>{texto2}</span>
                  <span className="precoAntigoProdutoInicial">{precoDe}</span>
                  &nbsp;
                  <span className="precoNovoProdutoInicial">{`${texto4} ${precoPor}!`}</span>
                  <br />
                  <br />
                  {texto5}
                </p>
              </>
            ) : (
              <>
                <p className="text">
                  {texto1}
                  <br />
                  <br />
                  <span className="precoNovoProdutoInicial">{`${texto4} ${precoPor}!`}</span>
                  <br />
                  <br />
                  {texto5}
                </p>
              </>
            )}
            <div className="sejaparceiro">
              {hiddenBtn ? (
                <div className="">
                  <Buttons
                    btnProduct
                    click={tooglePopup}
                    labelBtn="Comprar"
                    function="tooglePopup"
                    destaque={""}
                  />
                </div>
              ) : null}
            </div>
          </div>
          <div className="col-md-6 text-center mobile animated animatedFadeInUp fadeInUp">
            <img src={srcImg} alt={Titulo} />
          </div>
        </>
      );
    }
  }

  return (
    <>
      {isOpen && (
        <Form
          HandleClose={tooglePopup}
          content={
            <div>
              <h2>Texto</h2>
              <p>Formulário</p>
            </div>
          }
          idCertificado={produtoInicial.rubri_inid_rubricaproduto}
          titulo={produtoInicial.rubri_vcds_comercial}
          log={log}
        />
      )}
      <div className="Sections mtb-70 " style={{ background: `${cor}` }}>
        <div className="container">
          {(produtoInicial.length !== 0 && tipoLayout === 1) ? (
            <>
            Teste
            returnLayout(2)
            </>
          ) : <div className="row">{returnLayout()}</div>}
        </div>
      </div>
    </>
  );
}

export default Sections;
